import { Button, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceProcessingToolPanel extends Layout {
    buttonMarkReadyToProcess: Button;
    buttonSendBackToReview: Button;
    panelButtons: Panel;
    panelToolLeft: Panel;
    panelToolRight: Panel;
}
